import { FormArray, FormGroup } from '@angular/forms';
import { ShareholderFormType } from '@app/modules/job/models/form/shareholder-form-type';
import { ShareDistributionFormType } from '@app/modules/share-distribution/models/form/share-distributions-form-type';
import {
  CompanyShareholderInput,
  OfficerCompanyInput,
  OfficerCompanyType,
  OfficerPersonInput,
  OfficerPersonType,
  OfficerType,
  OfficerTypeEnum,
} from '@generated/graphql';
import { OfficerDialogState } from './officer-dialog-state.class';

export class ShareholderOfficerDialogState extends OfficerDialogState {
  shareholderControls: FormArray<FormGroup<ShareholderFormType>>;

  setShareholderControls(shareholderControls: FormArray): this {
    this.shareholderControls = shareholderControls;

    return this;
  }

  setTitle(): this {
    if (this.mode === 'new') {
      this.title = 'Add Shareholder';
    } else if (this.mode === 'edit') {
      this.title = 'Edit Shareholder';
    }

    return this;
  }

  setInformationLabel(): this {
    this.informationLabel = 'Shareholder Information';

    return this;
  }

  getShareDistributionsForm(): FormGroup<ShareDistributionFormType> {
    return this.officerFormState.shareDistributionForm;
  }

  prepareEditData(data: CompanyShareholderInput): this {
    let shareholdingDetails = undefined;

    if ('shareholdingDetails' in data) {
      shareholdingDetails = data.shareholdingDetails;
    }

    this.officerFormState.setEditData(
      data.officerPerson || data.officerCompany || undefined,
      shareholdingDetails,
    );

    return this;
  }

  setLookupData(officer: OfficerType, type: OfficerTypeEnum): this {
    let officerName = 'officerPerson';
    let officerProfile: OfficerPersonInput | OfficerCompanyInput;

    if (type === OfficerTypeEnum.Corporate) {
      officerName = 'officerCompany';
      const castedOfficer = officer.officerProfile as OfficerCompanyType;

      officerProfile = this.mapOfficerCompanyInput(castedOfficer);
    } else {
      const castedOfficer = officer.officerProfile as OfficerPersonType;

      officerProfile = this.mapOfficerPersonInput(castedOfficer);
    }

    const transformedOfficer = {
      id: officer.id,
      officerType: type,
      isNominee: false,
      [officerName]: officerProfile,
      refId: officer.id,
    };

    this.setSelectedOfficerType(type)
      .createOfficerForm()
      .prepareEditData(transformedOfficer)
      .disableOfficerFormForExistingReference();

    return this;
  }

  isOfficerFormValid(): boolean {
    const formValid = this.getOfficerForm().valid;
    const distributionFormValid =
      this.getShareDistributionsForm().getRawValue().shareDistributions
        .length >= 1 && this.getShareDistributionsForm().valid;

    if (this.getOfficerForm().disabled && distributionFormValid) {
      return true;
    }

    return formValid && distributionFormValid;
  }
}
